import { createSelector } from 'reselect'
import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current'
import getValueReduxUtil from 'modules/redux/utils/get-value/index.js'

export const isLoggedInTrainingUserSelect = createSelector(
  getCurrentTrainingUserSelect,
  (user) => {
    const id = getValueReduxUtil(user, 'id')
    return id > 0
  }
)
